import { SHELL_ICON_BUTTON_ACTIVE_SX } from '@components/v2/layout/AppTemplate/components/Header/header.styles';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { PackageX } from 'lucide-react';
import { useShowUnavailableProductsTrigger } from './hooks/useShowUnavailableProductsTrigger';

const ShowUnavailableProductsTrigger = () => {
  const { canChangeAdminOptions, showUnavailableProducts, label, handleClick } =
    useShowUnavailableProductsTrigger();

  if (!canChangeAdminOptions) {
    return null;
  }

  return (
    <Tooltip tabIndex={-1} TooltipContent={label}>
      <IconButton
        icon={PackageX}
        isActive={showUnavailableProducts}
        ariaPressed={showUnavailableProducts}
        ariaLabel={label}
        testId="show-unavailable-products-trigger"
        onClick={handleClick}
        sx={SHELL_ICON_BUTTON_ACTIVE_SX}
      />
    </Tooltip>
  );
};

export default ShowUnavailableProductsTrigger;
